"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatExecuteOnSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var constants_1 = require("../../constants");
var datetime_1 = require("../../utils/datetime");
var DROPDOWN_WIDTH = 154;
var RenderRepeatExecuteOnSelect = /** @class */ (function (_super) {
    tslib_1.__extends(RenderRepeatExecuteOnSelect, _super);
    function RenderRepeatExecuteOnSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isRepeatExecuteOnItemSelected = function (item) {
            return item.id === _this.props.repeatExecuteOn;
        };
        _this.getRepeatExecuteOnItem = function (repeatExecuteOn) {
            var _a = _this.props, intl = _a.intl, startDate = _a.startDate;
            return {
                id: repeatExecuteOn,
                title: intl.formatMessage({
                    id: "dialogs.schedule.email.repeats.execute.on." + repeatExecuteOn,
                }, {
                    date: datetime_1.getDate(startDate),
                    day: datetime_1.getIntlDayName(intl, startDate),
                    week: datetime_1.getWeek(startDate),
                }),
            };
        };
        _this.getRepeatExecuteOnItems = function () {
            return [constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH, constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK].map(_this.getRepeatExecuteOnItem);
        };
        _this.onRepeatExecuteOnChange = function (item) {
            _this.props.onChange(item.id);
        };
        return _this;
    }
    RenderRepeatExecuteOnSelect.prototype.render = function () {
        var _this = this;
        var repeatExecuteOnItems = this.getRepeatExecuteOnItems();
        var repeatExecuteOnItem = repeatExecuteOnItems.find(this.isRepeatExecuteOnItemSelected);
        return (React.createElement(sdk_ui_kit_1.Dropdown, { alignPoints: constants_1.DEFAULT_DROPDOWN_ALIGN_POINTS, className: "gd-schedule-email-dialog-repeat-execute-on s-gd-schedule-email-dialog-repeat-execute-on", renderBody: function (_a) {
                var closeDropdown = _a.closeDropdown, isMobile = _a.isMobile;
                return (React.createElement(sdk_ui_kit_1.DropdownList, { width: DROPDOWN_WIDTH, items: repeatExecuteOnItems, isMobile: isMobile, renderItem: function (_a) {
                        var item = _a.item;
                        return (React.createElement(sdk_ui_kit_1.SingleSelectListItem, { title: item.title, onClick: function () {
                                _this.onRepeatExecuteOnChange(item);
                                closeDropdown();
                            }, isSelected: repeatExecuteOnItem.id === item.id }));
                    } }));
            }, renderButton: function (_a) {
                var toggleDropdown = _a.toggleDropdown;
                return (React.createElement(sdk_ui_kit_1.DropdownButton, { value: repeatExecuteOnItem.title, onClick: toggleDropdown }));
            }, overlayPositionType: "sameAsTarget", overlayZIndex: constants_1.DEFAULT_DROPDOWN_ZINDEX }));
    };
    return RenderRepeatExecuteOnSelect;
}(React.PureComponent));
exports.RepeatExecuteOnSelect = react_intl_1.injectIntl(RenderRepeatExecuteOnSelect);
//# sourceMappingURL=RepeatExecuteOnSelect.js.map